export default function Letterbox() {
  // Cinematic 2.39:1 letterbox bars (subtle, fixed, non-blocking)
  return (
    <>
      <div
        data-testid="letterbox-top"
        aria-hidden
        className="fixed top-0 inset-x-0 h-[5vh] min-h-[24px] bg-black z-[60] pointer-events-none border-b border-white/[0.04]"
      />
      <div
        data-testid="letterbox-bottom"
        aria-hidden
        className="fixed bottom-0 inset-x-0 h-[5vh] min-h-[24px] bg-black z-[60] pointer-events-none border-t border-white/[0.04]"
      />
    </>
  );
}
